<template>
  <div>


    <div class="row">

      <div class="col-md-6 col-lg-4 col-xl-3" v-for="stat in stats" :key="stat.title">
        <stats-card>
          <div class="icon-big text-center text-warning" :class="`icon-${stat.type}`" slot="header">
            <i :class="stat.icon"></i>
          </div>
          <div class="numbers" slot="content">
            <p>{{stat.title}}</p>
            {{stat.value | spaceBetweenNumber}}
          </div>
        </stats-card>
      </div>
    </div>

       <h6 class="mb-4" v-if="date">Информация на {{date}} <span class="link" @click="refresh">обновить информацию</span></h6>

    <!-- <hr/>
      <br/>
        <div class="row">
     
            <div class="col-12 col-md-6 col-lg-6 col-xl-4">
                    <card>  
                        <h6>Данные аккаунта</h6>  
                        <br/>
                          <form>
                                <fg-input
                                    type="text"
                                    max="191"
                                    label="Ваша фамилия"
                                    v-model="last_name"
                                    placeholder=""
                                ></fg-input>
                                <fg-input
                                    type="text"
                                    max="191"
                                    label="Ваше имя"
                                    v-model="first_name"
                                    placeholder=""
                                ></fg-input>
                                <br/>
                                <p-button
                                        class="w-100 mb-3"
                                        type="warning"
                                        round
                                        @click.native.prevent="save('profile')">Сохранить</p-button>
                            </form>      
                    </card>
            </div>
            <div class="col-12 col-md-6 col-lg-6 col-xl-4">
                    <card>  
                        <h6>Изменить пароль</h6>  
                        <br/>
                          <form>
                                <fg-input
                                    type="password"
                                    max="191"
                                    label="Новый пароль"
                                    v-model="password"
                                    placeholder=""
                                ></fg-input>
                                <fg-input
                                    type="password"
                                    max="191"
                                    label="Повторите новый пароль"
                                    v-model="password_confirmation"
                                    placeholder=""
                                ></fg-input>
                                <br/>
                                <p-button
                                        class="w-100 mb-3"
                                        type="warning"
                                        round
                                        @click.native.prevent="save('password')">Сохранить</p-button>
                            </form>      
                    </card>
            </div>
      </div> -->
 
  </div>
</template>
<script>
import { StatsCard, ChartCard } from "@/components/index";
import { errorNotify } from "@/plugins/functions";
import Chartist from "chartist";
import {mapState} from 'vuex';
export default {
  components: {
    StatsCard,
    ChartCard
  },
  created() {
   
    if (this.user){
       this.first_name = this.user.first_name;
       this.last_name = this.user.last_name;
    }

    this.refresh();
  },
  methods: {
  save(type = 'profile'){

      let fileds = {};

      if (type=='profile'){
          fileds['first_name'] = this.first_name;
          fileds['last_name'] = this.last_name;
      }
      else if(type=='password'){
           fileds['password'] = this.password;
          fileds['password_confirmation'] = this.password_confirmation;
      }

       this.$loading(true);
          this.$http
              .post(`profile`, fileds)
              .then((response) => {
                  this.$notify({
                        title: "Успешно",
                        message: "Данные изменены",
                        icon: "ti-save",
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: "success",
               });

               this.$store.dispatch('setUser',response.data.data);

              })
              .catch((error) => {
     
                errorNotify(error, this.$notify);
              })
              .finally(() => {
                   this.$loading(false);
          });
    },
    refresh(){
         this.$loading(true);
          this.$http
              .get(`stats`)
              .then((response) => {
                  try {
                   var today = new Date();
                  var day = today.getDate();
                  var month = today.getMonth()+1;
                  var year = today.getFullYear();
                  var hour = today.getHours();
                  var min = today.getMinutes();
                  var sec = today.getSeconds();
                  this.date =  (day < 10 ? '0' +day : day ) +'/'+ (month < 10 ? '0' +month : month ) +'/'+year+ ' '+  (hour < 10 ? '0' +hour : hour ) + ":" + (min < 10 ? '0' +min : min )+ ":" +  (sec < 10 ? '0' +sec : sec );
                  } catch {}

                  this.stats = response.data.data;
              })
              .catch((error) => {
                errorNotify(error, this.$notify);
              })
              .finally(() => {
                setTimeout(() => {
                  this.$loading(false);
              }, 200);
          });
    }
  },
  data() {
    return {
      stats:[],
      date:null,
      first_name:'',
      last_name:'',
      password:'',
      password_confirmation:'',
    };
  },
  computed:{
     ...mapState(["user"]),
  }
};
</script>
